import { __awaiter } from "tslib";
import Chart from 'chart.js/auto';
import { useStore } from '@/store/store';
import { onMounted, ref, watch } from 'vue';
import ApiManager from '@/managers/apimanagers';
import dayjs from 'dayjs';
const borderColors = [
    'rgba(255, 99, 132, 0.9)',
    'rgba(54, 162, 235, 0.9)',
    'rgba(255, 206, 86, 0.9)',
    'rgba(75, 192, 192, 0.9)',
    'rgba(153, 102, 255, 0.9)',
    'rgba(255, 159, 64, 0.9)',
];
/**
 * @summary 資産グラフを表示するための処理
 */
export const useAssetsChart = () => {
    const store = useStore();
    // status
    const isLoading = ref(false);
    const summary = ref([]);
    const selectedSymbol = ref('');
    const assetsRange = ref(7);
    const chart = ref();
    const getMyAssetsSummary = (symbol, range) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const url = `/currency/${symbol}/assets?range=${range}&timezone=${store.state.userSettings.localTime}`;
            return yield ApiManager.get(url);
        }
        catch (err) {
            throw err;
        }
    });
    const changeBase = ({ range, symbol, refresh = false }) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (isLoading.value) {
            return;
        }
        assetsRange.value = range;
        if (refresh) {
            isLoading.value = true;
            summary.value = yield Promise.all(store.state.currencyInfo.map((currency) => getMyAssetsSummary(currency.symbol, range))).finally(() => (isLoading.value = false));
        }
        const defaultChart = (_a = (!!symbol
            ? summary.value.find((s) => s.symbol.toLocaleLowerCase() === symbol.toLocaleLowerCase())
            : summary.value.find((s) => s.variation))) !== null && _a !== void 0 ? _a : summary.value[0];
        !symbol && (selectedSymbol.value = defaultChart.symbol);
        const options = {
            scales: {
                y: {
                    suggestedMin: defaultChart.min,
                    suggestedMax: defaultChart.max,
                },
            },
            plugins: {
                legend: {
                    display: false,
                }
            }
        };
        createChart({
            labels: (_b = defaultChart.data) === null || _b === void 0 ? void 0 : _b.map((i) => dayjs(i.date).format('MM/DD')),
            datasets: [
                {
                    label: defaultChart.symbol.toUpperCase(),
                    data: defaultChart.data.map((i) => i.net_amount),
                    fill: false,
                    borderColor: borderColors[5 - (summary.value.findIndex((s) => s.symbol.toUpperCase() === defaultChart.symbol.toUpperCase()) % 6)],
                    tension: 0.1,
                    hidden: defaultChart.symbol !== defaultChart.symbol,
                }
            ],
        }, options);
    });
    const createChart = (data, options) => {
        if (chart.value) {
            chart.value.destroy();
        }
        const ctx = document.getElementById('assets-chart');
        chart.value = new Chart(ctx, {
            type: 'line',
            data,
            options,
        });
    };
    onMounted(() => {
        changeBase({ range: 7, refresh: true });
    });
    watch(() => store.state.userSettings.localTime, () => changeBase({ range: assetsRange.value, symbol: selectedSymbol.value, refresh: true }));
    watch(() => assetsRange.value, () => changeBase({ range: assetsRange.value, symbol: selectedSymbol.value, refresh: true }));
    watch(() => selectedSymbol.value, (_, oldVal) => (!!oldVal && changeBase({ range: assetsRange.value, symbol: selectedSymbol.value })));
    return { isLoading, chart, selectedSymbol, assetsRange, changeBase };
};
